import { render, staticRenderFns } from "./addtype.vue?vue&type=template&id=76d2c1a4&scoped=true&"
import script from "./addtype.vue?vue&type=script&lang=js&"
export * from "./addtype.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addtype.vue?vue&type=style&index=1&id=76d2c1a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d2c1a4",
  null
  
)

export default component.exports